import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import aboutSectionImage from "assets/images/icons/aboutSectionImage.jpeg";
import { useStyles } from "../styles";

const AboutSection: React.FC = () => {
  const styles = useStyles();
  return (
    <>
      <Grid container mb={4} textAlign="center">
        <Grid item xs={12}>
          <Typography variant="h1" fontWeight={900} mt={4}>
            C&D Waste Management
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={4} alignItems="center" justifyContent="center">
        <Grid item xs={12} md={7}>
          <Box sx={styles.aboutBox}>
            <Typography variant="h1" fontWeight={900} mb={4}>
              About
            </Typography>
            <Typography variant="body1" sx={styles.aboutText}>
              The C&D waste management portal, developed and maintained by the
              Thane Municipal Corporation, is designed to manage waste generated
              from various construction and demolition (C&D) activities in the
              city. C&D waste dumps have been identified as a significant source
              of air pollution in the area. Builders, contractors, and other C&D
              waste generators are encouraged to use this portal to submit their
              waste management plans, contributing to a cleaner city.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={5} display="flex" justifyContent="center">
          <img
            src={aboutSectionImage}
            alt="C&D Waste Management"
            style={styles.aboutImage}
            loading="lazy"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default AboutSection;
